import React from 'react';
import { Typography, Divider } from '@mui/material';

import DialogBase from './DialogBase';
import SharedPlannenByOrganisatie from '../../authorization/organisaties/SharedPlannenByOrganisaties';

interface DialogSharedPlansByOrganisatieProps {
  open: boolean;
  organisatieId: string;
  organisatieName: string;
  isZonderGebied: boolean;
  onClose: () => void;
}

const DialogSharedPlansByOrganisatie: React.FC<DialogSharedPlansByOrganisatieProps> = ({
  open,
  organisatieId,
  organisatieName,
  isZonderGebied,
  onClose,
}) => {

  return (
    <DialogBase
      open={open}
      title={`Organisatie: ${organisatieName} - Gedeelde plannen`}
      onClose={onClose}
      width="900px"
      minWidth="700px"
    >
      <Typography variant="subtitle2" sx={{ mb: 2, color: 'text.secondary' }}>
        <strong>Organisatie:</strong> {organisatieName} {organisatieId && `(${organisatieId})`}
      </Typography>
      <Divider sx={{ mb: 2 }} />
      
      {organisatieId && (
        <SharedPlannenByOrganisatie 
          isZonderGebied={isZonderGebied} 
          organisatieId={organisatieId} 
        />
      )}
    </DialogBase>
  );
};

export default DialogSharedPlansByOrganisatie;
